import React from 'react';
import './App.css';
import TermsOfService from './TermsOfService';
import TermsOfPrivacy from './TermsOfPrivacy';
import TermsOfPositionInformation from './TermsOfPositionInformation';
import TermsOfMarketing from './TermsOfMarketing';
import { BrowserRouter, Route, Link, Switch } from "react-router-dom";

import PlusTermsOfService from './PlusTermsOfService';
import PlusTermsOfPrivacy from './PlusTermsOfPrivacy';


function App() {
  return (
    <>
    {/* <TermsOfService />
    <TermsOfPrivacy />
    <TermsOfPositionInformation /> */}
    <BrowserRouter>
        {/* <Link to="/Service">서비스 이용 약관</Link><br/>
        <Link to="/Privacy">개인정보 및 민감정보 처리방침 약관</Link><br/>
        <Link to="PositionInfomation">위치기반서비스 이용약관</Link><br/> */}
        <Switch>
          <Route exact path="/service" component={TermsOfService}/>
          <Route path="/privacy" component={TermsOfPrivacy}/>
          <Route path="/position" component={TermsOfPositionInformation}/>
          <Route path="/marketing" component={TermsOfMarketing}/>
          <Route path="/plus_service" component={PlusTermsOfService}/>
          <Route path="/plus_privacy" component={PlusTermsOfPrivacy}/>
        </Switch>
    </BrowserRouter>
    </>
  );
}

export default App;
